export function fetch(id) { return { type: 'SPONSORS/FETCH', id } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/sponsors.js